import React from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import { IconButton, Popover } from 'material-ui';
import FlatButton from '../../tc-ui/flat-button-with-loader.jsx';
import { PopoverAnimationFromTop } from 'material-ui/Popover';

const getTitle = R.cond([
  [R.equals('offers'), R.always('Special Offers')],
  [R.equals('seasonRates'), R.always('Rates')],
  [R.equals('extras'), R.always('Extra')],
  [R.T, R.always('Rates')],
]);

const HeaderBar = ({ saving, updateType, locationName, goToContract, popOverOpen, popOverAnchorEl, closePopOver, massRateChange, goToContractOrOpenPover }) => (
  <div style={{ height: '48px', backgroundColor: '#00bcd4' }}>
    <IconButton
      iconClassName="tc-icon-arrow_back"
      iconStyle={{ color: 'white' }}
      onClick={goToContractOrOpenPover}
    >
      <Popover
        open={popOverOpen}
        anchorEl={popOverAnchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        animation={PopoverAnimationFromTop}
        onRequestClose={closePopOver}
      >
        <div>
          <div style={{ color: 'black', width: '206px', padding: '12px' }}>
            You have unsaved changes.  Would you like to save them before you exit this tool?
          </div>
          <FlatButton label="Exit" secondary onTouchTap={goToContract} />
          <FlatButton label="Save & Exit" secondary style={{ float: 'right' }}
                      loader={saving}
                      onTouchTap={() => {
                        massRateChange()
                        .then(() => goToContract())
                      }}
          />
        </div>
      </Popover>
    </IconButton>
    <span style={{ fontSize: '16px', position: 'relative', top: '-3px', color: 'white' }}>{`Edit ${getTitle(updateType)}${locationName ? ` for ${locationName}` : ''}`}</span>
  </div>
);

const mapStateToProps = ({ contracting }) => ({
  updateType: contracting.massRateChange.get('updateType'),
  locationName: contracting.massRateChange.get('locationName'),
  popOverOpen: contracting.massRateChange.get('popOverOpen'),
  popOverAnchorEl: contracting.massRateChange.get('popOverAnchorEl'),
});

export default connect(mapStateToProps)(HeaderBar);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/container-header.jsx